import { axiosPost } from '../ServiceBase';

export const getLinkTeleconsulta = async (idAfiliado) => {
  if (idAfiliado) {
    return axiosPost(`/v1/ordenes-teleconsulta/${idAfiliado}/generar-link`);
  }

  return null;
};
